import "./useSelectOrders.scss";

import { useCallback, useState } from "react";
import { useUpdateEffect } from "react-use";

import { CheckMark } from "@client/components/reusable/check-mark/check-mark";
import { useRootContext } from "@client/context/RootContext";
import { Order } from "@client/stores";

export default function useSelectOrders(packedOrders: Order[]) {
	const {
		vendorStore: { orderOperations, vendorDetails },
	} = useRootContext();
	const [selectedOrders, setSelectedOrders] = useState<number[]>([]);

	useUpdateEffect(() => {
		const actualSelectedOrders = selectedOrders.filter((orderId) =>
			packedOrders.some((order) => order.id === orderId)
		);

		setSelectedOrders(actualSelectedOrders);
	}, [packedOrders.length]);

	function toggleSelectAllOrders() {
		if (selectedOrders.length === packedOrders.length) {
			setSelectedOrders([]);
		} else {
			setSelectedOrders(packedOrders.map((order) => order.id));
		}
	}
	function toggleSelectOrder(orderId: number) {
		if (selectedOrders.includes(orderId)) {
			setSelectedOrders(selectedOrders.filter((id) => id !== orderId));
		} else {
			setSelectedOrders([...selectedOrders, orderId]);
		}
	}
	function handleSubmitSelectedOrders() {
		orderOperations.collectedBulkOrders(selectedOrders);

		setSelectedOrders([]);
	}

	const SelectAllOrdersCheckbox = useCallback(() => {
		return (
			vendorDetails?.delivery_dates_select_all && (
				<CheckMark
					selected={
						packedOrders.length > 0 &&
						selectedOrders.length === packedOrders.length
					}
					onClick={toggleSelectAllOrders}
				/>
			)
		);
	}, [packedOrders.length, selectedOrders.length]);

	const SelectedOrdersSummary = useCallback(() => {
		return (
			selectedOrders.length > 0 && (
				<div className="submit-selected-orders-container">
					<div className="submit-selected-orders-controls">
						<button
							className="submit-selected-orders-button submit"
							onClick={handleSubmitSelectedOrders}
						>
							סופק ללקוח
						</button>
						<button
							className="submit-selected-orders-button cancel"
							onClick={() => setSelectedOrders([])}
						>
							ביטול
						</button>
					</div>
					<div className="submit-selected-orders-header">
						<div className="submit-selected-orders-title">
							{selectedOrders.length} הזמנות נבחרו{" "}
						</div>
						<div className="submit-selected-orders-subtitle">
							לחיצה על הכפתור תעדכן את תאריך האספקה בפועל עבור כולם
						</div>
					</div>
				</div>
			)
		);
	}, [selectedOrders, handleSubmitSelectedOrders]);

	return {
		selectedOrders,
		setSelectedOrders,
		toggleSelectOrder,
		toggleSelectAllOrders,
		SelectAllOrdersCheckbox,
		SelectedOrdersSummary,
	};
}
